import { PAGE_SIZE_OPTIONS } from '../filterModel';

/** Server paging: the page and size are sent to the API; the total comes back. */
export function DashboardPager({ page, pageSize, total, shown, onPage, onPageSize }: {
  page: number; pageSize: number; total: number; shown: number; onPage: (page: number) => void; onPageSize: (size: number) => void;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const current = Math.min(page, pages);
  const first = (current - 1) * pageSize;
  return (
    <div className="tpd-pager">
      <label className="tpd-rows">
        Rows per page:
        <select value={pageSize} onChange={(e) => onPageSize(Number(e.target.value))}>
          {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </label>
      <span className="tpd-pager__count" role="status" aria-live="polite" data-testid="pager-count">
        {shown > 0 ? `${first + 1}-${first + shown} of ${total} ${total === 1 ? 'payment' : 'payments'}` : '0 payments'}
      </span>
      <nav className="tpd-pager__nav" aria-label="Pagination">
        <button type="button" disabled={current <= 1} onClick={() => onPage(current - 1)}>Previous</button>
        <span>Page {current} of {pages}</span>
        <button type="button" disabled={current >= pages} onClick={() => onPage(current + 1)}>Next</button>
      </nav>
    </div>
  );
}
